var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.268,
    height: 39.737,
    viewBox: "0 0 26.268 39.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-cola-drink-6289990",
    transform: "translate(-11.505 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36629",
    "data-name": "Trac\\xE9 36629",
    d: "M45.682,33.105,44.72,31.49H34.837l-.968,1.615a.7.7,0,0,0-.09.333V48.231a.688.688,0,0,0,.038.224.655.655,0,0,0,.615.429H45.118a.661.661,0,0,0,.615-.429.634.634,0,0,0,.038-.224V33.438A.7.7,0,0,0,45.682,33.105Zm-1.865,3v8.159a1.227,1.227,0,1,1-2.455,0V36.1a1.227,1.227,0,1,1,2.455,0Z",
    transform: "translate(-7.999 -10.949)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36630",
    "data-name": "Trac\\xE9 36630",
    d: "M25.2,1.731V3.993H18.83V1.731A.734.734,0,0,1,19.561,1h4.9a.734.734,0,0,1,.731.731Z",
    transform: "translate(-2.63 0)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36631",
    "data-name": "Trac\\xE9 36631",
    d: "M25.262,57a1.479,1.479,0,0,1-.987.365H14.488a1.525,1.525,0,0,1-1.474-1.109l-.564-1.263a10.119,10.119,0,0,1-.9-5.147,10.223,10.223,0,0,1,.6-2.544H23.827v6.614a2.592,2.592,0,0,0,1.07,2.1,1.811,1.811,0,0,0,.25.776l.115.212Z",
    transform: "translate(0 -16.626)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36632",
    "data-name": "Trac\\xE9 36632",
    d: "M26.644,20.015A2.729,2.729,0,0,0,25.061,22.5a2.8,2.8,0,0,0,.1.737H12.012a7.914,7.914,0,0,1,1.961-5.755l1.045-1.064a4.7,4.7,0,0,0,1.359-3.307V12.1h6.364v1.013A4.67,4.67,0,0,0,24.1,16.42l1.045,1.064a6.7,6.7,0,0,1,1.5,2.532Z",
    transform: "translate(-0.177 -3.986)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2920",
    "data-name": "Groupe 2920",
    transform: "translate(15.847 5.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36633",
    "data-name": "Trac\\xE9 36633",
    d: "M25.343,8.055v.795a.393.393,0,0,1-.391.391H18.671a.393.393,0,0,1-.391-.391V8.055a.387.387,0,0,1,.391-.385h6.281A.387.387,0,0,1,25.343,8.055Z",
    transform: "translate(-18.28 -7.67)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36634",
    "data-name": "Trac\\xE9 36634",
    d: "M25.343,8.055v.795a.393.393,0,0,1-.391.391H18.671a.393.393,0,0,1-.391-.391V8.055a.387.387,0,0,1,.391-.385h6.281A.387.387,0,0,1,25.343,8.055Z",
    transform: "translate(-18.28 -7.67)",
    fill: "#cea95a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36635",
    "data-name": "Trac\\xE9 36635",
    d: "M45.313,27.892a.294.294,0,0,1-.006.064.781.781,0,0,1-.775.711H36.205a.784.784,0,0,1-.679-.4.743.743,0,0,1-.09-.314.218.218,0,0,1-.006-.064.783.783,0,0,1,.077-.346.77.77,0,0,1,.7-.436h8.325A.785.785,0,0,1,45.313,27.892Z",
    transform: "translate(-8.591 -9.376)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36636",
    "data-name": "Trac\\xE9 36636",
    d: "M45.309,60.58l-.417.711-.3.513a.646.646,0,0,1-.564.327H36.7a.656.656,0,0,1-.57-.327l-.3-.513-.41-.711H45.3Z",
    transform: "translate(-8.588 -21.394)",
    fill: "#cea95a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36637",
    "data-name": "Trac\\xE9 36637",
    d: "M24.53,32.03l-.16.276A2.576,2.576,0,0,0,24,33.639v6.55H12.333L12,32.036H24.53Z",
    transform: "translate(-0.178 -11.143)",
    fill: "#cea95a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrink);
export default __webpack_public_path__ + "static/media/iconDrink.effaf5661a2b44f73d5aab9608aadea0.svg";
export { ForwardRef as ReactComponent };